import type { ReactNode } from "react";

interface PageHeaderProps {
  eyebrow: string;
  title: string;
  subtitle: string;
  actions?: ReactNode;
  compact?: boolean;
}

export function PageHeader({ eyebrow, title, subtitle, actions, compact }: PageHeaderProps) {
  return (
    <header className={`menu-page__header ${compact ? "overview-page__header" : ""}`}>
      <div className="min-w-0">
        <p className="menu-page__eyebrow">{eyebrow}</p>
        <h1 className={`menu-page__title ${compact ? "overview-page__title" : ""}`}>{title}</h1>
        <p className={`menu-page__subtitle ${compact ? "overview-page__subtitle" : ""}`}>
          {subtitle}
        </p>
      </div>
      {actions ? (
        <div className={`menu-page__header-actions ${compact ? "overview-page__header-actions" : ""}`}>
          {actions}
        </div>
      ) : null}
    </header>
  );
}
